import { render, staticRenderFns } from "./ScopingQuestions.vue?vue&type=template&id=3d533fa8&scoped=true&"
import script from "./ScopingQuestions.vue?vue&type=script&lang=js&"
export * from "./ScopingQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d533fa8",
  null
  
)

export default component.exports